import React from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../../ui/utils/Responsive';
import illustration from '../../../../../../../assets/flights-not-found.svg?reference';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

export const ErrorMessage = () => {
	const { t } = useTranslation();

	return (
		<StyledErrorMessage>
			<img src={illustration} alt="" />
			<p>{t('security_checkpoint_subtitle_error')}</p>
		</StyledErrorMessage>
	);
};

const StyledErrorMessage = styled.div`
	padding: 80px 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: 0;
	}

	img {
		display: block;
		width: 80%;
		max-width: 220px;
		margin: 0 auto 40px;
	}

	p {
		max-width: 448px;
		text-align: center;
		margin-left: auto;
		margin-right: auto;
	}
`;
